const PIN_MARKER_PATH =
  "M17.499 2.15186C24.145 2.15202 30.1649 7.26479 30.165 15.1099C30.165 17.6872 29.1735 20.4003 27.3262 23.228C25.4774 26.0578 22.7351 29.0596 19.1377 32.2368L19.1318 32.2427C18.2017 33.0504 16.8111 33.0502 15.8809 32.2427L15.875 32.2378C12.27 29.0603 9.52361 26.058 7.67285 23.228C5.82352 20.4002 4.83203 17.6872 4.83203 15.1099C4.8322 7.26466 10.8529 2.15186 17.499 2.15186ZM17.499 12.9019C16.4471 12.9019 15.582 13.767 15.582 14.8188C15.5822 15.8706 16.4472 16.7349 17.499 16.7349C18.5507 16.7347 19.4149 15.8705 19.415 14.8188C19.415 13.7671 18.5508 12.902 17.499 12.9019Z";

const SVG_NS = "http://www.w3.org/2000/svg";

type PinMarkerElementOptions = {
  fillColor: string;
  strokeColor?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
  anchorOffsetY?: number;
  zIndex?: number;
};

export function createPinMarkerElement({
  fillColor,
  strokeColor = "#E5EDEA",
  strokeWidth = 2,
  width = 35,
  height = 35,
  anchorOffsetY = 2,
  zIndex,
}: PinMarkerElementOptions): HTMLDivElement {
  const wrapper = document.createElement("div");
  wrapper.style.width = `${width}px`;
  wrapper.style.height = `${height}px`;
  wrapper.style.display = "flex";
  wrapper.style.alignItems = "center";
  wrapper.style.justifyContent = "center";
  wrapper.style.pointerEvents = "auto";
  wrapper.style.transform = `translateY(${anchorOffsetY}px)`;
  if (zIndex !== undefined) {
    wrapper.style.zIndex = String(zIndex);
  }

  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("xmlns", SVG_NS);
  svg.setAttribute("width", String(width));
  svg.setAttribute("height", String(height));
  svg.setAttribute("viewBox", "0 0 35 35");
  svg.setAttribute("fill", "none");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");

  const path = document.createElementNS(SVG_NS, "path");
  path.setAttribute("d", PIN_MARKER_PATH);
  path.setAttribute("fill", fillColor);
  path.setAttribute("stroke", strokeColor);
  path.setAttribute("stroke-width", String(strokeWidth));
  path.setAttribute("vector-effect", "non-scaling-stroke");

  svg.appendChild(path);
  wrapper.appendChild(svg);

  return wrapper;
}
